export { default as Typography } from './Typography';
export { default as Colors } from './Colors';
export { default as Shadows } from './Shadows';
export { default as Animation } from './Animation';

import { ColorName, ColorValue } from './Colors';
import { ShadowName, ShadowValue } from './Shadows';
import { TypographyName } from './Typography';

export type ColorName = ColorName;
export type ColorValue = ColorValue;
export type ShadowName = ShadowName;
export type ShadowValue = ShadowValue;
export type TypographyName = TypographyName;
